export default {
  id: 132,
  title: 'Target #132 - Letter S',
  url: 'https://cssbattle.dev/play/132',
  colors: ['#4F77FF', '#FFFFFF', '#1038BF'],
  solution:
    '<a a><a b><a c><style>[a],[c]{width:240}[b],[c]{left:80;background:#fff;border-radius:9in}body{background:#4f77ff}a{position:fixed}[a]{top:70;left:80;height:50;background:#fff;border-radius:10px;box-shadow:20px -20px #1038bf,0 110px #fff,-20px 130px #1038bf}[b]{top:100;width:20;height:60;box-shadow:220px 40px #fff}[c]{top:140;height:20}</style>',
}
